// src/components/roles/index.jsx
import React, { useEffect, useState } from 'react';
import { useApi } from '../../hooks/useApi';
import { Icon } from '@iconify/react';
import Modal from '../common/Modal';

const Roles = () => {
  const { get, post, put } = useApi();
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [roleName, setRoleName] = useState('');
  const [permissionsList, setPermissionsList] = useState([]);
  const [chainsList, setChainsList] = useState([]); 
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [selectedChains, setSelectedChains] = useState([]);

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const data = await get('roles');
      //console.log(data);
      setRoles(data);
    } catch (error) {
      console.error('Error al obtener roles:', error);
    }
    setLoading(false);
    };


  const fetchPermissions = async () => {
    try {
      const data = await get('ListaPermisos');
        setPermissionsList(data);
        //console.log(data);
    } catch (error) {
      console.error('Error al obtener permisos:', error);
    }
    };

    const fetchChains = async () => {
        try {
            const data = await get('ListaCadenas');
            setChainsList(data);
        } catch (error) {
            console.error('Error al obtener cadenas:', error);
        }
    };

  useEffect(() => {
    fetchRoles();
    fetchPermissions();
    fetchChains();
  }, []);

  const handleAddRole = () => {
    setSelectedRole(null);
    setRoleName('');
    setSelectedPermissions([]);
    setSelectedChains([]);
    setShowModal(true);
  };

  /*const handleEditRole = (role) => {
    setSelectedRole(role);
    setRoleName(role.name);
    setSelectedPermissions(role.permissions || []);
    setSelectedChains(role.chains || []);
    setShowModal(true);
    };*/

    const normalizePermIds = (arr) =>
        (arr ?? []).map(Number).filter(Number.isInteger);

    const handleEditRole = (role) => {
        setSelectedRole(role);
        setRoleName(role.name ?? "");
        setSelectedPermissions(normalizePermIds(role.dmePermissions)); // ← números
        setSelectedChains(role.chains ?? []);                          // ← strings
        setShowModal(true);
    };

  const togglePermission = (id) => {
  setSelectedPermissions((prev) =>
    prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id]
  );
    };

    const toggleChain = (chainName) => {
        setSelectedChains(prev =>
            prev.includes(chainName)
                ? prev.filter(c => c !== chainName) // si ya estaba, la quitas
                : [...prev, chainName]              // si no estaba, la agregas
        );
    };

    const handleSaveRole = async () => {

      const cleanChains = Array.from(new Set(
            (selectedChains ?? []).map(c => (c || '').trim()).filter(Boolean)
        ));

      try {
        if (selectedRole) {
        await post('ActualizaRol',  {
            id: selectedRole.id,
            name: roleName,
            dmePermissions: selectedPermissions,
            chains: cleanChains,
            });
        } else {
        await post('GuardaRoles', {
            Name: roleName,
            dmePermissions: selectedPermissions,
            chains: cleanChains,
        });
      }
      setShowModal(false);
      fetchRoles();
    } catch (error) {
    console.error('Error al guardar rol:', error.response?.data || error);
    }
  };

  return (
    <div className="p-4">
        <div className="flex justify-between items-center pb-2 ">
          <h1 className="text-lg font-bold text-gray-700">Gestión de Roles</h1>
          <button
            onClick={handleAddRole}
            className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            <Icon icon="mdi:plus" />
            Nuevo Rol
          </button>
        </div>
      {/* Card principal */}
      <div className="bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="p-4">
          {loading ? (
            <p>Cargando...</p>
          ) : (
            <div className="overflow-x-auto">
  <table className="w-full border-collapse text-sm shadow-lg rounded-lg overflow-hidden">
    <thead>
      <tr className="bg-gradient-to-r from-blue-100 to-blue-50 text-gray-700 uppercase text-xs tracking-wider">
        <th className="border-b px-4 py-2 text-left">ID</th>
        <th className="border-b px-4 py-2 text-left">Nombre</th>
        <th className="border-b px-4 py-2 text-left">Permisos</th>
        <th className="border-b px-4 py-2 text-left">Cadenas</th>
        <th className="border-b px-4 py-2 text-center">Acciones</th>
      </tr>
    </thead>
    <tbody className="bg-white">
                                      {roles.map((role) => (
        <tr
          key={role.id}
          className="hover:bg-gray-50 transition-colors duration-150"
        >
          <td className="border-b px-4 py-2">{role.id}</td>
          <td className="border-b px-4 py-2 font-medium text-gray-800">{role.name}</td>
          <td className="border-b px-4 py-2">
            {role.dmePermissions?.length > 0 ? (
              Object.entries(
                role.dmePermissions
                  .map(pid => permissionsList.find(p => p.permissionId === pid))
                  .filter(Boolean)
                  .reduce((acc, perm) => {
                      if (!acc[perm.permissionModule]) acc[perm.permissionModule] = [];
                      acc[perm.permissionModule].push(perm.permissionName);
                    return acc;
                  }, {})
              ).map(([modulo, perms]) => (
                <div key={modulo} className="mb-1">
                  <span className="font-semibold text-gray-700 mr-2">{modulo}:</span>
                  {perms.map((p, i) => (
                    <span
                      key={i}
                      className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full mr-1 mb-1"
                    >
                      {p}
                    </span>
                  ))}
                </div>
              ))
            ) : (
              <span className="text-gray-400 italic">Sin permisos</span>
            )}
        </td>
        {/* Cadenas asignadas */}
        <td className="border-b px-4 py-2">
            {role.chains?.length > 0 ? (
                role.chains.map((chainName, i) => (
                    <span
                        key={i}
                        className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full mr-1 mb-1"
                    >
                        {chainName}
                    </span>
                ))
            ) : (
                <span className="text-gray-400 italic">Sin cadenas</span>
            )}
        </td>
          <td className="border-b px-4 py-2 text-center">
            <button
              onClick={() => handleEditRole(role)}
              className="text-blue-600 hover:text-blue-800 p-1 rounded transition-colors duration-150"
            >
              <Icon icon="mdi:pencil" width={20} height={20} />
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

          )}
        </div>
      </div>

      {/* Modal para agregar/editar */}
      {showModal && (
        <Modal
          show={showModal}
          title={selectedRole ? 'Editar Rol' : 'Nuevo Rol'}
          onClose={() => setShowModal(false)}
        >
          <div className="space-y-4">
            <div>
              <label className="block font-semibold mb-1">Nombre del rol</label>
              <input
                type="text"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                className="w-full border rounded px-3 py-2"
              />
            </div>

            <div>
                <label className="block font-semibold mb-2 text-gray-700">Permisos</label>

                <div className="max-h-60 overflow-y-auto p-2 bg-gray-50 border border-gray-200 rounded-lg shadow-sm">
                    {permissionsList.length > 0 ? (
                        <div className="grid grid-cols-2 gap-2">
                            {permissionsList.map((perm) => {
                                const pid = Number(perm.permissionId); // dentro de llaves de función
                                return (
                                    <label
                                        key={pid}
                                        className="flex items-center gap-2 cursor-pointer bg-white px-2 py-1 rounded hover:bg-blue-50 transition-colors"
                                    >
                                        <input
                                            type="checkbox"
                                            className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                                            checked={selectedPermissions.includes(pid)}
                                            onChange={() => togglePermission(pid)}
                                        />
                                        <span className="text-gray-700 text-sm">
                                            {perm.permissionModule} – {perm.permissionName}
                                        </span>
                                    </label>
                                );
                            })}
                        </div>
                    ) : (
                        <span className="text-gray-400 italic text-sm">No hay permisos disponibles</span>
                    )}
                </div>
            </div>

            {/* Cadenas */}
            <div>
                <label className="block font-semibold mb-2 text-gray-700">Cadenas</label>
                <div className="max-h-40 overflow-y-auto p-2 bg-gray-50 border border-gray-200 rounded-lg shadow-sm">
                    {chainsList.length > 0 ? (
                        <div className="grid grid-cols-2 gap-2">
                            {chainsList.map((chainName) => (
                                <label
                                    key={chainName}
                                    className="flex items-center gap-2 cursor-pointer bg-white px-2 py-1 rounded hover:bg-green-50 transition-colors"
                                >
                                    <input
                                        type="checkbox"
                                        className="w-4 h-4 text-green-600 border-gray-300 rounded"
                                        checked={selectedChains.includes(chainName)}
                                        onChange={() => toggleChain(chainName)}
                                    />
                                    <span className="text-gray-700 text-sm">{chainName}</span>
                                </label>
                            ))}
                        </div>
                    ) : (
                        <span className="text-gray-400 italic text-sm">
                            No hay cadenas disponibles
                        </span>
                    )}
                </div>
            </div>


            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowModal(false)}
                className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
              >
                Cancelar
              </button>
              <button
                onClick={handleSaveRole}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 flex items-center gap-2"
              >
                <Icon icon="mdi:content-save" />
                Guardar
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Roles;
